/* eslint-disable react/require-default-props */
import React from "react";

import { Modal } from "antd";

import * as S from "./style";

type ConfirmationModalProps = {
  title: string;
  description: string;
  onClose: () => void;
  onSubmit: () => void;
  isLoading: boolean;
  cancelText?: string;
  submitText?: string;
};

export function ConfirmationModal({
  description,
  isLoading,
  onClose,
  onSubmit,
  title,
  cancelText = "Cancelar",
  submitText = "Confirmar",
}: ConfirmationModalProps) {
  const handleClose = () => {
    if (isLoading) {
      return;
    }

    onClose();
  };
  return (
    <Modal
      title={<span style={{ fontWeight: "bold" }}>{title}</span>}
      visible
      onCancel={handleClose}
      style={{
        borderRadius: "8px",
      }}
    >
      <S.Container>
        <S.TitleWrapper>
          <S.Title>{description}</S.Title>
        </S.TitleWrapper>
        <S.ButtonWrapper>
          <S.CancelButton onClick={onClose} disabled={isLoading}>
            {cancelText}
          </S.CancelButton>

          <S.UpdateDomainButton onClick={onSubmit} disabled={isLoading}>
            {isLoading && <S.Loader />} {submitText}
          </S.UpdateDomainButton>
        </S.ButtonWrapper>
      </S.Container>
    </Modal>
  );
}
